module.exports = __webpack_public_path__ + "img/006徐向南.b162916d.jpg";